import { render, staticRenderFns } from "./ToolbarChangeLang.component.vue?vue&type=template&id=0bdef330&scoped=true&"
import script from "./ToolbarChangeLang.component.vue?vue&type=script&lang=js&"
export * from "./ToolbarChangeLang.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdef330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VBtnToggle,VListItem})
